import React from 'react';
import { GlassSidebar } from './GlassSidebar';
import { Header } from './Header';
import useUIStore from '@/app/store/ui.store';
import { cn } from '@/shared/utils/helpers/cn';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const { isSidebarOpen, isSidebarCollapsed } = useUIStore();

  return (
    <div className="min-h-screen bg-glass-page flex">
      {/* Sidebar */}
      <div
        className={cn(
          'fixed inset-y-0 left-0 z-50 transition-all duration-300',
          isSidebarCollapsed ? 'w-16' : 'w-[220px]',
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'
        )}
      >
        <GlassSidebar />
      </div>

      {/* Sidebar Overlay for Mobile */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-neutral-900/50 lg:hidden"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div
        className={cn(
          'flex-1 flex flex-col transition-all duration-300',
          'lg:ml-[220px]',
          isSidebarCollapsed && 'lg:ml-16'
        )}
      >
        {/* Header */}
        <Header />

        {/* Page Content */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
